import topbar from 'topbar';

export default () => {
  // Show progress bar on live navigation and form submits
  topbar.config({ barColors: { 0: '#29d' }, shadowColor: 'rgba(0, 0, 0, .3)' });
  window.addEventListener('phx:page-loading-start', () => topbar.show());
  window.addEventListener('phx:page-loading-stop', () => topbar.hide());
};
